import React, { useEffect, useState } from 'react'
// import { socket } from 'socket'
import { socket, ensureSocketAuthed } from './socket/index'
import Views from './views'
import Loading from 'components/loading/Loading'
import { ACTION } from 'consts'
import { useDispatch, useSelector } from 'react-redux'
import { ConfigProvider, notification } from 'antd'
import { ordersAPI } from 'actions/orders/orders'
import { getOrders } from 'apis/order'
import { getAppSetting } from 'apis/app-setting'
import { clearBrowserCache, decodeJWT } from 'utils'
import useAutoUpdate from 'hooks/use-auto-update'
import dayjs from './dayjsConfig'

export default function App() {
  const dispatch = useDispatch()
  const dataUser = useSelector((state) => state.login.dataUser)

  // Tự nạp bản mới khi deploy — user không phải Ctrl+Shift+R, không hiện banner nào
  useAutoUpdate()

  //config notification
  notification.config({ duration: 2 })

  const getAllOrders = async () => {
    try {
      const res = await getOrders()
      if (res.status === 200) dispatch(ordersAPI(res.data))
    } catch (error) {}
  }

  const _getSettingApp = async () => {
    try {
      const res = await getAppSetting()
      if (res.status === 200) {
        if (res.data.data) {
          document.querySelector("link[rel*='icon']").href =
            res.data.data.link_logo || ''
          dispatch({ type: 'GET_SETTING_APP', data: res.data.data })
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    clearBrowserCache()

    // Always fetch app settings (public API, no auth needed)
    // This ensures logo and branding load on login page too
    _getSettingApp()

    // Auto-clear old JWT tokens without balance field
    try {
      const persistRoot = localStorage.getItem('persist:root')
      if (persistRoot) {
        const parsed = JSON.parse(persistRoot)
        if (parsed.login) {
          const loginData = JSON.parse(parsed.login)
          const token = loginData.accessToken

          if (token) {
            const payload = decodeJWT(token)
            // Check if JWT is missing balance field (old token)
            if (payload && !payload.balance) {
              console.log('🔄 Detected old JWT without balance field, clearing all storage...')
              localStorage.clear()
              sessionStorage.clear()
              notification.warning({
                message: 'Session Expired',
                description: 'Your session has been updated. Please login again.',
                duration: 5
              })
              // Reload page to redirect to login
              setTimeout(() => {
                window.location.href = '/login'
              }, 1000)
            }
          }
        }
      }
    } catch (e) {
      console.error('Error checking JWT:', e)
    }
  }, [])

  useEffect(() => {
    if (
      localStorage.getItem('accessToken') &&
      localStorage.getItem('refreshToken')
    ) {
      dispatch({
        type: ACTION.LOGIN,
        data: {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken'),
        },
      })
    }
  }, [])

  useEffect(() => {
    if (
      localStorage.getItem('accessToken') &&
      localStorage.getItem('refreshToken')
    ) {
      socket.on(
        JSON.parse(localStorage.getItem('username')) + '_order',
        (data) => {
          //khi có order mới rót về thì gọi lại api get all order và lưu vào reducer
          getAllOrders()
        }
      )

      // Chuông thông báo (plan 261023-2005 phase 02): socket gắn JWT ngay sau login ⇒ server join room user:<username>.
      ensureSocketAuthed()
    }
  }, [dataUser])

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <Loading />
      <Views />
    </ConfigProvider>
  )
}
